import { normalizeDrivingRouteGroupKey } from "@utils/mode_tool/modeRoute";

export function normalizeImportedRouteGroup(value = "") {
  const normalizedValue = String(value || "").trim();
  if (!normalizedValue) return "main";
  if (/^detour[a-j]$/i.test(normalizedValue)) {
    return String(normalizedValue.slice(-1)).toUpperCase();
  }
  return normalizeDrivingRouteGroupKey(normalizedValue);
}

function escapeImportedRichTextHtml(value = "") {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function formatImportedRichText(value = "") {
  const normalizedText = String(value || "").replace(/\r\n?/g, "\n").trim();
  if (!normalizedText) return "";
  if (/<(?:p|br|strong|em|u|ul|ol|li|h[1-6])\b/i.test(normalizedText)) {
    return normalizedText;
  }
  const formattedLines = normalizedText.split("\n").map((line) => {
    const escapedLine = escapeImportedRichTextHtml(line);
    return escapedLine.replace(
      /(^|[\s>])#([^\s#<]+)/g,
      (_, prefix, content) => `${prefix}<strong>${content}</strong>`,
    );
  });
  const paragraphs = [];
  let currentParagraph = [];
  formattedLines.forEach((line) => {
    if (!line.trim()) {
      if (currentParagraph.length) {
        paragraphs.push(`<p>${currentParagraph.join("<br />")}</p>`);
        currentParagraph = [];
      } else {
        paragraphs.push("<p><br /></p>");
      }
      return;
    }
    currentParagraph.push(line);
  });
  if (currentParagraph.length) {
    paragraphs.push(`<p>${currentParagraph.join("<br />")}</p>`);
  }
  return paragraphs.join("");
}

export function normalizeImportedLocalizedField(value = {}, languageItems = [], formatter = null) {
  const source = value && typeof value === "object" ? value : {};
  return (Array.isArray(languageItems) ? languageItems : []).reduce((acc, language) => {
    const iso = String(language?.lng_iso || language?.iso || "").toLowerCase();
    if (!iso) return acc;
    acc[iso] = {
      value: typeof formatter === "function"
        ? formatter(source?.[iso] ?? "")
        : String(source?.[iso] ?? ""),
      id: "",
    };
    return acc;
  }, {});
}

export function buildImportedMediaFileName(url = "", fallbackBaseName = "media") {
  try {
    const pathname = new URL(String(url || "")).pathname || "";
    const filename = pathname.split("/").pop() || "";
    if (filename) return filename;
  } catch (error) {
    // A non-URL input uses the existing fallback name.
  }
  return `${fallbackBaseName}`;
}

export function isFirebaseStorageUrl(url = "") {
  return /firebasestorage\.googleapis\.com/i.test(String(url || ""));
}
